
const state = {
  global_outOfStockRecordsData: null
}

const mutations = {
  SET_GLOBAL_OUTOFSTOCKRECORDSDATA: (state, data) => {
    state.global_outOfStockRecordsData = data
  }
}

const actions = {

}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
